import { controls, currencyToNumber, grouped } from "../../controls";

const rpcf13 = {
  label: "Talathi Wise Consolidated Report",
  starting: true,
  url: "rp101m",
  pageLabel: "Talathi Wise Consolidated Report",
  pageType: "history",
  // filteraction: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Talathi Wise Consolidated Report",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    pivot: true,

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Talathi",
        accessor: "talathi_name",
        rwidth: "*"
      },
      {
        Header: "Total Amount",
        accessor: "total_amount"
      },
      {
        Header: "Total Count",
        accessor: "total_count"
      },
      {
        Header: "Returned Amount",
        accessor: "returned_amount"
      },
      {
        Header: "Returned Count",
        accessor: "returned_count"
      }
    ]
  }
};

export default rpcf13;